import { secondsToHms, timeToSeconds } from "../../../Components/TimeConvertions";

const MARGEN_VENTANA_MIN = 15;
const DIA_SEG = 86400;

const acotarSalto = (salto, min, max) => Math.min(Math.max(salto, min), max);

const ventanaDesdeBase = (base, minutos) => {
  const seg = timeToSeconds(base) + minutos * 60;

  return {
    hora: secondsToHms(seg),
    salto: Math.floor(seg / DIA_SEG),
  };
};

export { MARGEN_VENTANA_MIN, acotarSalto, ventanaDesdeBase };
